import { createMuiTheme } from '@material-ui/core/styles';
import { plPL } from '@material-ui/core/locale';

export const krajowaBazaTheme = createMuiTheme(
    {
        palette: {
            primary: {
                main: '#0064ac',
            },
        },
        typography: {
            fontFamily: 'Arial,Verdana,Helvetica,sans-serif',
            h4: {
                fontSize: '2rem',
            },
            h3: {
                fontSize: '18px',
            },
            body1: {
                fontSize: '16px',
            },
        },
        overrides: {},
    },
    plPL,
);
